import { isValidRedirect } from '@/features/common/utils/isValidRedirect';

/**
 * TikTok OAuth 로그인을 시작합니다.
 * Client-side only.
 */
export async function signInWithTikTok(options?: { redirectTo?: string | null }): Promise<void> {
  if (typeof window === 'undefined') {
    return;
  }

  const tiktokAuthUrl = new URL('/api/auth/tiktok', window.location.origin);

  if (options?.redirectTo && isValidRedirect(options.redirectTo)) {
    tiktokAuthUrl.searchParams.set('next', options.redirectTo);
  }

  window.location.replace(tiktokAuthUrl.toString());
}
